document.addEventListener('DOMContentLoaded', function() {
  const productShareBtn = document.querySelector('.product-share-btn');
  const minimogModal = document.querySelector('.minimog-modal');
  const modalOverlay = document.querySelector('.minimog-modal .modal-overlay');
  const closeButton = document.querySelector('.button-close-modal'); // Assuming close button has class 'close-button'
  const body = document.querySelector("body");
  
  function openModal() {
    minimogModal.classList.add('open');
    body.classList.add('overflow-hidden');
  }
  
  function closeModal() {
    minimogModal.classList.remove('open');
    body.classList.remove('overflow-hidden');
  }
  
  if (productShareBtn && minimogModal && modalOverlay && closeButton) {
    productShareBtn.addEventListener('click', openModal);
  
    closeButton.addEventListener('click', closeModal);
  
    modalOverlay.addEventListener('click', function(event) {
      // if (!minimogModal.contains(event.target)) {
        closeModal();
      // }
    });
  }
  
});

/**********************************
 ACCORDION BY DEFAULT OPEN
*/ 


// var detailsElements = document.querySelectorAll('.accordion details');

// function closeOtherDetails(selectedDetails) {
//   detailsElements.forEach(details => {
//     if (details !== selectedDetails && details.open) {
//         details.open = false;
//     }
//   });
// }

// detailsElements.forEach(details => {
//   details.addEventListener('toggle', () => {
//     if (details.open) {
//         closeOtherDetails(details);
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function() {
  // Select all details elements
  var detailsElements = document.querySelectorAll('.product__accordion details');
  
  // Set the first details element to be open by default
  if (detailsElements.length > 0) {
    detailsElements[0].setAttribute('open', true);
  }

  // Function to close other details when one is opened
  function closeOtherDetails(selectedDetails) {
    detailsElements.forEach(function(details) {
      if (details !== selectedDetails && details.hasAttribute('open')) {
        details.removeAttribute('open');
      }
    });
  }

  // Event listener for details elements
  detailsElements.forEach(function(details) {
    details.addEventListener('toggle', function() {
      if (details.hasAttribute('open')) {
        closeOtherDetails(details);
      }
    });
  });
});